import React from 'react';
import { Link } from "gatsby";
import { makeStyles, } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      color: "#b60011",   
    }
  },
}));

const BlockSeaStateMorning = (props) => {
  const hoverStyle = useStyles();
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var d = new Date();
  var dayName = days[d.getDay()];

  return (
    <React.Fragment>
       <Link className={hoverStyle.root} to="/shipping">
       <h2 style={{fontSize:"18px", fontWeight:"600"}}>Sea state {dayName} morning</h2>
       <img src={`${process.env.MET_SEASTATEMORNINGIMAGE}/Sea%20State/Sea%20State%20AM.png`} alt="" />    
          </Link>
    </React.Fragment>
  )
}

export default BlockSeaStateMorning
